import React from 'react'

export default function Fail() {
    return (
        <div className='text-center p-24 text-2xl font-bold'>
            Payment Fail
        </div>
    )
}
